import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";

const CustomBreadcrumb = ({ LinkPath, BreadcrumbName }) => {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={(theme) => ({
        zIndex: 100,
        backgroundColor: "background",
        [theme.breakpoints.down("lg")]: {
          marginLeft: "1rem",
        },
      })}
    >
      <Link
        underline="hover"
        sx={{
          color: "title.main",
          fontWeight: "bold",
          fontSize: "0.8rem",
        }}
        component={RouterLink}
        to={LinkPath}
      >
        {BreadcrumbName}
      </Link>
    </Breadcrumbs>
  );
};

export default CustomBreadcrumb;
